import LegalLayout from "../components/LegalLayout";
import { PRIVACY_POLICY_TEXT } from "../constants/legalText";

export default function Privacy() {
  return <LegalLayout title="プライバシーポリシー" text={PRIVACY_POLICY_TEXT} />;
}
